import { createContext, useEffect, useState } from 'react';

import { User } from 'firebase/auth';
import { useAuthState } from 'react-firebase-hooks/auth';
import ReactGA from 'react-ga';

import { isUserVerified } from 'utils/permissions';

import { auth } from '../services/firebase';

interface UserData {
  user: User | null | undefined;
  loading: boolean;
  userVerified: boolean;
  error: Error | undefined;
}

/** Handles user authentication data */
export const useUserData = (): UserData => {
  const [user, loading, error] = useAuthState(auth);
  const [userVerified, setUserVerified] = useState(false);

  useEffect(() => {
    const loadUserPermissions = async (): Promise<void> => {
      setUserVerified(await isUserVerified(user?.uid));
    };

    ReactGA.set({ userId: user?.uid });

    loadUserPermissions();
  }, [user]);

  return { user, loading, userVerified, error };
};

export const UserContext = createContext<UserData | null>(null);
